<template>
  <div>
    <div class="line">
      <b-navbar toggleable="lg" :type="darkSet">
        <b-navbar-brand to="/">
          <svg
            class="logo"
            width="122"
            height="32"
            viewBox="0 0 122 32"
            :fill="colour"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M117.196 8.43958C117.196 8.14654 117.254 7.8828 117.37 7.61907C117.486 7.35533 117.631 7.1209 117.835 6.94507C118.038 6.73995 118.241 6.59342 118.503 6.47621C118.764 6.35899 119.025 6.30038 119.316 6.30038C119.606 6.30038 119.868 6.35899 120.129 6.47621C120.39 6.59342 120.623 6.73995 120.797 6.94507C120.971 7.1502 121.146 7.35533 121.262 7.61907C121.378 7.8828 121.436 8.14654 121.436 8.43958C121.436 8.73262 121.378 8.99636 121.262 9.26009C121.146 9.52383 121 9.72896 120.797 9.93408C120.594 10.1392 120.39 10.2857 120.129 10.3736C119.868 10.4909 119.606 10.5495 119.316 10.5495C119.025 10.5495 118.764 10.4909 118.503 10.3736C118.241 10.2564 118.009 10.1099 117.835 9.93408C117.631 9.72896 117.486 9.52383 117.37 9.26009C117.254 8.99636 117.196 8.73262 117.196 8.43958ZM117.544 8.43958C117.544 8.67401 117.602 8.90844 117.689 9.14288C117.776 9.348 117.922 9.55313 118.067 9.72896C118.241 9.90478 118.415 10.022 118.648 10.1099C118.851 10.1978 119.083 10.2564 119.345 10.2564C119.606 10.2564 119.839 10.1978 120.042 10.1099C120.245 10.022 120.449 9.87548 120.623 9.72896C120.797 9.55313 120.913 9.37731 121 9.14288C121.088 8.93775 121.146 8.70331 121.146 8.43958C121.146 8.17584 121.088 7.94141 121 7.73628C120.913 7.53115 120.768 7.32603 120.623 7.1502C120.478 6.97438 120.274 6.85716 120.042 6.76925C119.839 6.68134 119.606 6.62273 119.345 6.62273C119.083 6.62273 118.851 6.68134 118.648 6.76925C118.444 6.85716 118.241 7.00368 118.067 7.1502C117.893 7.32603 117.776 7.50185 117.689 7.73628C117.573 7.94141 117.544 8.17584 117.544 8.43958ZM118.503 7.23811H119.345C119.461 7.23811 119.577 7.23811 119.664 7.26742C119.781 7.29672 119.868 7.32603 119.955 7.38463C120.042 7.44324 120.1 7.50185 120.158 7.58976C120.216 7.67767 120.245 7.79489 120.245 7.91211C120.245 8.08793 120.187 8.23445 120.1 8.35167C120.013 8.46888 119.868 8.52749 119.693 8.5861L120.332 9.64104H119.81L119.258 8.64471H118.938V9.64104H118.503V7.23811ZM119.258 8.26375C119.374 8.26375 119.49 8.23445 119.606 8.20515C119.722 8.14654 119.781 8.05863 119.781 7.91211C119.781 7.79489 119.722 7.70698 119.635 7.64837C119.548 7.58976 119.432 7.58976 119.316 7.58976H118.938V8.26375H119.258Z"
              ></path>
              <path
                d="M20.8252 6.30035C22.4227 6.30035 23.933 6.71061 25.3271 7.50182C26.7503 8.32233 27.825 9.40658 28.6382 10.7839C29.4224 12.1612 29.8291 13.6557 29.8291 15.2674C29.8291 16.8791 29.4224 18.4029 28.6382 19.8095C27.854 21.2161 26.7503 22.3004 25.3852 23.1209C24.0201 23.9414 22.4807 24.3223 20.8252 24.3223C18.3854 24.3223 16.3233 23.4432 14.5806 21.7143C12.8669 19.956 11.9956 17.8461 11.9956 15.3553C11.9956 12.6886 12.9541 10.4615 14.9001 8.67398C16.6428 7.09156 18.5888 6.30035 20.8252 6.30035ZM20.8833 10.3443C19.5472 10.3443 18.4726 10.8132 17.5722 11.7509C16.7008 12.6886 16.2652 13.8608 16.2652 15.326C16.2652 16.8205 16.7008 18.022 17.5722 18.9597C18.4435 19.8974 19.5472 20.337 20.8833 20.337C22.2193 20.337 23.323 19.8681 24.2234 18.9304C25.0948 17.9927 25.5595 16.7912 25.5595 15.326C25.5595 13.8608 25.1238 12.6593 24.2525 11.7509C23.3521 10.8132 22.2484 10.3443 20.8833 10.3443Z"
              ></path>
              <path
                d="M13.0411 23.2381C12.1697 22.359 11.4727 21.3919 10.9789 20.3663C10.2818 20.3663 8.97481 20.3077 8.85863 20.3077C7.52258 20.3077 6.41888 19.8388 5.54754 18.9304C4.6762 17.9927 4.24053 16.7912 4.24053 15.2967V10.022H11.0951C11.676 8.90843 12.4602 7.91209 13.4477 7.00366C13.7091 6.76923 13.9995 6.5348 14.2609 6.32967H4.26957V0H0V15.2967C0 17.8169 0.464715 19.9267 2.17835 21.685C3.89199 23.4432 6.38983 24.3223 8.82959 24.3223C9.58475 24.3223 12.373 24.3223 14.2609 24.3223C13.8543 24 13.4477 23.6191 13.0411 23.2381Z"
              ></path>
              <path
                d="M107.524 6.30035C109.121 6.30035 110.631 6.71061 112.026 7.50182C113.449 8.32233 114.523 9.40658 115.337 10.7839C116.121 12.1612 116.527 13.6557 116.527 15.2674C116.527 16.8791 116.121 18.4029 115.337 19.8095C114.552 21.2161 113.449 22.3004 112.084 23.1209C110.718 23.9414 109.208 24.3223 107.553 24.3223C105.113 24.3223 103.051 23.4432 101.308 21.7143C99.5944 19.956 98.723 17.8461 98.723 15.3553C98.723 12.6886 99.6815 10.4615 101.627 8.67398C103.341 7.09156 105.316 6.30035 107.524 6.30035ZM107.611 10.3443C106.275 10.3443 105.2 10.8132 104.3 11.7509C103.428 12.6886 102.993 13.8608 102.993 15.326C102.993 16.8205 103.428 18.022 104.3 18.9597C105.171 19.8974 106.275 20.337 107.611 20.337C108.947 20.337 110.05 19.8681 110.951 18.9304C111.822 17.9927 112.287 16.7912 112.287 15.326C112.287 13.8608 111.851 12.6593 110.98 11.7509C110.05 10.8132 108.947 10.3443 107.611 10.3443Z"
              ></path>
              <path
                d="M57.9732 10.8132C57.189 9.43591 56.0853 8.32236 54.6621 7.53115C53.2389 6.71063 51.7576 6.32968 50.1602 6.32968C47.9528 6.32968 45.9777 7.12089 44.2931 8.6447C42.3471 10.4322 41.3887 12.6594 41.3887 15.326V31.2088H45.6292V23.033C46.9943 23.8828 48.5046 24.3224 50.1892 24.3224C51.8448 24.3224 53.3551 23.9121 54.7202 23.1209C56.0853 22.3297 57.189 21.2161 57.9732 19.8095C58.7574 18.4029 59.164 16.8791 59.164 15.2674C59.164 13.685 58.7865 12.1905 57.9732 10.8132ZM53.5584 18.9011C52.6871 19.8388 51.5543 20.3077 50.2183 20.3077C48.8822 20.3077 47.7785 19.8388 46.9072 18.9304C46.0358 17.9927 45.6002 16.7912 45.6002 15.2967C45.6002 13.8608 46.0358 12.6594 46.9072 11.7216C47.7785 10.7839 48.8822 10.315 50.2183 10.315C51.5834 10.315 52.6871 10.7839 53.5584 11.6923C54.4297 12.6007 54.8654 13.8022 54.8654 15.2674C54.8945 16.7912 54.4297 17.9927 53.5584 18.9011Z"
              ></path>
              <path
                d="M97.2998 0H93.0592V7.61905C91.6941 6.73993 90.1548 6.30037 88.4992 6.30037C86.9018 6.30037 85.3914 6.71062 83.9973 7.50183C82.5741 8.32235 81.4994 9.40659 80.6862 10.7839C79.902 12.1612 79.4954 13.6557 79.4954 15.2674C79.4954 16.8791 79.902 18.4029 80.6862 19.8095C81.4704 21.2161 82.5741 22.3004 83.9392 23.1209C85.3043 23.9414 86.8437 24.3223 88.4702 24.3223C90.9099 24.3223 92.9721 23.4432 94.7148 21.7143C96.4284 19.956 97.2998 17.8462 97.2998 15.3553C97.2998 15.3553 97.2998 15.3553 97.2998 15.326V0ZM91.7522 18.9304C90.8809 19.8681 89.7772 20.3077 88.4411 20.3077C87.1051 20.3077 86.0014 19.8388 85.101 18.9011C84.2296 17.9634 83.7649 16.7619 83.7649 15.2967C83.7649 13.8315 84.2006 12.63 85.0719 11.7216C85.9433 10.8132 87.047 10.3443 88.4121 10.3443C89.7481 10.3443 90.8228 10.8132 91.7232 11.7509C92.5945 12.6886 93.0302 13.8608 93.0302 15.326C93.0592 16.7912 92.6236 17.9927 91.7522 18.9304Z"
              ></path>
              <path
                d="M75.6906 16.5861H78.0723C78.1303 16.1465 78.1594 15.7363 78.1594 15.2967C78.1594 13.685 77.7528 12.1905 76.9686 10.8132C76.1844 9.43591 75.0807 8.32236 73.6575 7.53115C72.2343 6.71063 70.753 6.32968 69.1555 6.32968C66.9481 6.32968 64.9731 7.12089 63.2885 8.6447C61.3425 10.4322 60.384 12.6594 60.384 15.326C60.384 17.8169 61.2554 19.9561 62.969 21.685C64.6827 23.4432 66.7739 24.2931 69.2136 24.2931C70.8692 24.2931 72.3795 23.8828 73.7446 23.0916C75.1097 22.3004 76.2134 21.1868 76.9976 19.7802C77.259 19.3407 77.4623 18.8718 77.6366 18.4029H72.9604C72.8442 18.5788 72.728 18.7253 72.5828 18.8718C71.7115 19.8095 70.5787 20.2784 69.2427 20.2784C67.9066 20.2784 66.8029 19.8095 65.9316 18.9011C65.3216 18.2564 64.9441 17.4945 64.7407 16.5568H73.7446H75.6906V16.5861ZM69.2427 10.3443C70.6078 10.3443 71.7115 10.8132 72.5828 11.7216C73.0475 12.2198 73.3961 12.7766 73.5994 13.4506H64.915C65.1474 12.8059 65.4669 12.2491 65.9316 11.7509C66.8029 10.8132 67.9066 10.3443 69.2427 10.3443Z"
              ></path>
              <path
                d="M40.2849 10.3443C40.8948 9.11354 41.7371 7.99999 42.8117 7.00365C42.8698 6.94504 43.596 6.38827 43.6831 6.30035C42.6956 6.30035 41.0691 6.30035 40.0235 6.30035C37.8161 6.30035 35.841 7.09156 34.1564 8.61537C32.2104 10.3736 31.252 12.63 31.252 15.2967V24.3516H35.4925V15.2967C35.4925 13.8608 35.9282 12.6593 36.7995 11.7216C37.6708 10.7839 38.7745 10.315 40.1106 10.315C40.1687 10.3443 40.2268 10.3443 40.2849 10.3443Z"
              ></path>
            </g>
            <defs>
              <clipPath id="clip0">
                <path d="M0 0H121.436V32H0V0Z" fill="white"></path>
              </clipPath>
            </defs></svg
        ></b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse
          id="nav-collapse"
          is-nav
          :class="{
            dark: darkSet === 'dark',
            light: darkSet === 'light'
          }"
        >
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <template v-for="(menuItem, index) in menuItems">
              <b-nav-item
                :class="{
                  dark: darkSet === 'dark',
                  light: darkSet === 'light'
                }"
                v-if="menuItem.parent === 0 && menuItem.slug !== 'home'"
                :key="index"
                :to="{
                  path: '/' + menuItem.slug,
                  params: menuItem.slug
                }"
              >
                <span v-if="menuItem.slug !== 'get-in-touch'">{{
                  menuItem.title.rendered
                }}</span>
                <b-button
                  :class="{
                    dark: darkSet === 'dark',
                    light: darkSet === 'light'
                  }"
                  v-else
                  >{{ menuItem.title.rendered }}</b-button
                >
              </b-nav-item>
            </template>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
export default {
  props: ["panel"],
  data() {
    return {
      menuItems: [],
      hover: false,
      hoverLink: "",
      hoverLinkTitle: ""
    };
  },
  computed: {
    colour() {
      if (this.panel === true) {
        var fill = "#fff";
      } else {
        fill === "#000";
      }
      return fill;
    },
    darkSet() {
      if (this.panel === true) {
        var label = "dark";
      } else {
        label = "light";
      }
      return label;
    },
    page() {
      var pageName = "";
      if (Object.keys(this.$route.params).length === 0) {
        pageName = "Home";
      } else {
        pageName = this.$route.params;
      }
      return pageName;
    }
  },
  mounted() {
    apiCall
      .wpInfo(
        "/wp-json/wp/v2/pages?orderby=menu_order&order=asc&_fields[]=title&_fields[]=menu_order&_fields[]=id&_fields[]=parent&_fields[]=slug&per_page=99"
      )
      .then(({ data }) => {
        this.menuItems = data;
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
        throw error;
      });
  }
};
</script>

<style scoped>
::v-deep .navbar {
  background-color: transparent;
  z-index: 100;
  height: 88px;
}

::v-deep .nav-item {
  align-self: center;
  padding: 0 20px;
}
::v-deep .nav-link {
  color: inherit !important;
}
.line{
  padding: 0 100px;
}
@media only screen and (max-width: 990px) {
  .line{
  padding: 0 0 0 100px;
}
  ::v-deep .navbar {
    padding: 0.5rem 0;
  }
  ::v-deep #nav-collapse.dark {
    background-color: #1e202c;
  }
  ::v-deep #nav-collapse.light {
    background-color: #fff;
  }
  ::v-deep .nav-item {
    padding: 30px;
  }
  ::v-deep .navbar-brand {
    padding-left: 1rem;
  }
  ::v-deep .navbar-toggler {
    margin-right: 2rem;
  }
}
@media only screen and (max-width: 450px) {
  .line{
    padding: 0;
  }
  ::v-deep .navbar {
    background-color: #f0eeed;
    margin-top: 0;
  }
  svg {
    fill: #1e202c !important;
  }
  ::v-deep .navbar-dark .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.5%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  }
  ::v-deep .navbar-dark .navbar-toggler {
    color: #1e202c;
    border-color: rgba(30, 32, 44, 0.1);
  }
}
</style>
